export default __webpack_public_path__ + "static/media/life.195db630.svg";